import dayjs from 'dayjs';

export const deepTrimStrings = <T,>(input: T): T => {
  if (typeof input === 'string') return input.trim() as T;
  if (dayjs.isDayjs(input)) return input;
  if (Array.isArray(input)) return input.map(deepTrimStrings) as T;
  if (input && typeof input === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(input as Record<string, unknown>)) {
      out[k] = deepTrimStrings(v);
    }
    return out as T;
  }
  return input;
};

